var base = require('settings/teams/update-team-name');

Vue.component('spark-update-team-name', {
    mixins: [base]
});



// WEBPACK FOOTER //
// ./resources/js/spark-components/settings/teams/update-team-name.js